import React from "react";
import PropTypes from "prop-types";

import { STREAM_TYPE, DEFAULT_CARD_HEIGHT } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";
import TagStreamHeader from "stream/components/TagStreamHeader";
import FullStoryCard from "cards/containers/FullStoryCard";
import TagStreamHelmet from "stream/components/TagStreamHelmet";

class TagStream extends React.Component {
  render() {
    return (
      <React.Fragment>
        <TagStreamHelmet slug={this.props.match.params.tag} />
        <TagStreamHeader slug={this.props.match.params.tag} />
        <StandardLayout
          main={
            <Stream
              type={STREAM_TYPE.TAG}
              lookup={this.props.match.params.tag}
              onlyShowTitleForA11y={true}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.FULL_STORY_CARD}
              contentComponent={FullStoryCard}
            />
          }
          complementary={<LatestStories />}
        />
      </React.Fragment>
    );
  }
}

TagStream.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      tag: PropTypes.string.isRequired,
    }),
  }),
};

export default TagStream;
